import {
  ONBOARDING_BOOKING_STEPS,
  ONBOARDING_STEPS,
  ONBOARDING_SUBSCRIPTION_STEPS,
  OnboardingFlow,
} from '../redux/providers/const'

export const getOnboardingSteps = (
  preferredMode: 'booking' | 'subscription' | null,
): OnboardingFlow => {
  switch (preferredMode) {
    case 'booking':
      return ONBOARDING_BOOKING_STEPS
    case 'subscription':
      return ONBOARDING_SUBSCRIPTION_STEPS
    default:
      return ONBOARDING_STEPS
  }
}
